"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../../Icon");
var _Tooltip = _interopRequireDefault(require("../../Tooltip"));
var _style = require("./style");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const shouldItemMoveRight = (item, hasSelectedItems, hideSearch) => !item.selected && (hasSelectedItems || !hideSearch) && !(item.component && !hasSelectedItems);
const SelectItemTooltipWrapper = props => {
  const {
    item,
    keyMap
  } = props;
  const tooltip = item[keyMap ? keyMap.tooltip : 'tooltip'];
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, tooltip ? ( /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    label: tooltip,
    position: "bottom"
  }, /*#__PURE__*/_react.default.createElement(SelectItem, Object.assign({}, props)))) : ( /*#__PURE__*/_react.default.createElement(SelectItem, Object.assign({}, props))));
};
const SelectItem = _ref => {
  let {
    item,
    onClick,
    hovered,
    keyMap,
    hasSelectedItems,
    getItemId,
    hideSearch,
    capitalizeItemLabel,
    onItemClick,
    showCheckmark
  } = _ref;
  const tooltip = item[keyMap ? keyMap.tooltip : 'tooltip'];
  let title = item[keyMap ? keyMap.title : 'title'];
  if (tooltip) title = null;
  return /*#__PURE__*/_react.default.createElement(_style.SelectItemStyled, {
    onClick: onItemClick || onClick,
    hovered: hovered,
    id: getItemId(item),
    disabled: item.disabled
  }, /*#__PURE__*/_react.default.createElement(_style.SelectItemLabel, {
    capitalizeItemLabel: capitalizeItemLabel,
    hideSearch: hideSearch,
    hasSelectedItems: hasSelectedItems,
    hasComponent: item.component
  }, item.selected && showCheckmark && ( /*#__PURE__*/_react.default.createElement(_style.IconWrapper, null, /*#__PURE__*/_react.default.createElement(_Icon.Checkmark, {
    color: "grayDarker"
  }))), !item.iconEnd && item.icon && ( /*#__PURE__*/_react.default.createElement(_style.SelectItemIcon, {
    iconEnd: item.iconEnd,
    hovered: hovered
  }, item.icon)), /*#__PURE__*/_react.default.createElement(_style.SelectItemTitle, {
    moveRight: shouldItemMoveRight(item, hasSelectedItems, hideSearch),
    title: title
  }, item.component && ( /*#__PURE__*/_react.default.createElement(_style.IconWrapper, {
    custom: true
  }, /*#__PURE__*/_react.default.createElement(_style.SelectItemCustom, {
    dangerouslySetInnerHTML: {
      __html: item.component(item)
    }
  }))), /*#__PURE__*/_react.default.createElement(_style.Title, null, item[keyMap ? keyMap.title : 'title'])), item.iconEnd && item.icon && ( /*#__PURE__*/_react.default.createElement(_style.SelectItemIcon, {
    iconEnd: item.iconEnd,
    hovered: hovered
  }, item.icon)), item.hotKeyPrompt && ( /*#__PURE__*/_react.default.createElement(_style.HotKeyPrompt, {
    hovered: hovered
  }, item.hotKeyPrompt))));
};
SelectItem.propTypes = {
  item: _propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    onItemClick: _propTypes.default.func,
    selected: _propTypes.default.bool,
    icon: _propTypes.default.node,
    iconEnd: _propTypes.default.bool,
    component: _propTypes.default.func,
    tooltip: _propTypes.default.string,
    disabled: _propTypes.default.bool
  }).isRequired,
  onClick: _propTypes.default.func.isRequired,
  onItemClick: _propTypes.default.func.isRequired,
  getItemId: _propTypes.default.func.isRequired,
  hovered: _propTypes.default.bool,
  capitalizeItemLabel: _propTypes.default.bool,
  keyMap: _propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.string,
    tooltip: _propTypes.default.string
  }),
  hasSelectedItems: _propTypes.default.bool,
  hideSearch: _propTypes.default.bool,
  multiSelect: _propTypes.default.bool,
  showCheckmark: _propTypes.default.bool
};
SelectItem.defaultProps = {
  hovered: undefined,
  keyMap: undefined,
  hasSelectedItems: undefined,
  hideSearch: undefined,
  multiSelect: undefined,
  capitalizeItemLabel: true,
  showCheckmark: true
};
var _default = exports.default = SelectItemTooltipWrapper;